export default __webpack_public_path__ + "static/media/3.94bc47ed.webp";